/* ============================================
   Smart Defense Section - v8
   - Grid mode: no JS needed (static layout)
   - Scroll mode: auto-play carousel with prev/play/next controls
   ============================================ */

(function() {
  function initSection(section) {
    const track = section.querySelector('[data-grid-inner]');
    if (!track) return;

    // Only run for scroll mode
    if (!track.parentElement.classList.contains('mode-scroll')) return;

    const cards = track.querySelectorAll('.sd-card');
    if (cards.length < 2) return;

    const prevBtn = section.querySelector('[data-arrow="prev"]');
    const nextBtn = section.querySelector('[data-arrow="next"]');
    const playBtn = section.querySelector('[data-play]');

    const interval = parseInt(track.parentElement.dataset.scrollInterval || '4000', 10);
    let autoplay = null;
    let isPlaying = true;

    function getStep() {
      const card = cards[0];
      const gap = parseInt(getComputedStyle(track).gap) || 18;
      return card.offsetWidth + gap;
    }

    function isAtEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function isAtStart() {
      return track.scrollLeft <= 2;
    }

    function scrollNext() {
      if (isAtEnd()) {
        // Loop back to start
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      }
    }

    function scrollPrev() {
      if (isAtStart()) {
        // Loop to end
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      }
    }

    function start() {
      if (!isPlaying) return;
      stop();
      autoplay = setInterval(scrollNext, interval);
    }

    function stop() {
      if (autoplay) {
        clearInterval(autoplay);
        autoplay = null;
      }
    }

    function setPlaying(playing) {
      isPlaying = playing;
      if (playBtn) {
        playBtn.classList.toggle('is-playing', playing);
        playBtn.setAttribute('aria-label', playing ? 'Pause autoplay' : 'Play autoplay');
      }
      if (playing) {
        start();
      } else {
        stop();
      }
    }

    // Wire up controls
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollPrev();
        // Reset autoplay timer so manual nav doesn't immediately get overridden
        if (isPlaying) start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollNext();
        if (isPlaying) start();
      });
    }
    if (playBtn) {
      playBtn.addEventListener('click', () => setPlaying(!isPlaying));
    }

    // Pause on hover (track only — not buttons)
    track.addEventListener('mouseenter', () => { if (isPlaying) stop(); });
    track.addEventListener('mouseleave', () => { if (isPlaying) start(); });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else if (isPlaying) {
        start();
      }
    });

    // Start (initial state is playing)
    start();
  }

  function init() {
    document.querySelectorAll('.smart-defense').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', function(e) {
    const target = e.target.querySelector('.smart-defense');
    if (target) initSection(target);
  });
})();